module.exports = __webpack_public_path__ + "img/icon-question.52b8a0f0.svg";